import React, { useCallback, useState } from 'react';
import Modal, { ModalFooter } from '@amzn/meridian/modal';
import Row from '@amzn/meridian/row';
import Button from '@amzn/meridian/button';
import { ContactData } from '../../api/ContactListening/schema';
import ContactListeningContent from './ContactListeningContent';
import ContactListeningMultitaskingBox from './ContactListeningMultitaskingBox';
import Column from '@amzn/meridian/column';
import { useIntl, FormattedMessage } from 'react-intl';
import { CLClickstream } from './utils/ContactListeningHelpers';
import { Feature, isFeatureEnabled } from '../../config/FeaturesConfig';

export interface ContactListeningModalProps {
  loadingState: string;
  showModal: boolean;
  setShowModal: any;
  contactId: string;
  contactListeningData: ContactData;
  contactListeningParams: any;
  CLClickstream: CLClickstream;
}

const ContactListeningModal: React.FC<ContactListeningModalProps> = ({
  loadingState,
  showModal,
  setShowModal,
  contactId,
  contactListeningData,
  contactListeningParams,
  CLClickstream,
}: ContactListeningModalProps): React.ReactElement => {
  const intl = useIntl();
  const onClose = useCallback(() => setShowModal(false), []);
  const contactListeningMultitaskEnabled = isFeatureEnabled(
    Feature.CONTACT_LISTENING_MULTITASK
  );
  const [openContactTranscript, setOpenContactTranscript] = useState(true);
  const contactListeningContentColumn = (
    <Column alignmentHorizontal='stretch'>
      <ContactListeningContent
        loadingState={loadingState}
        contactId={contactId}
        contactListeningData={contactListeningData}
        contactListeningParams={contactListeningParams}
        CLClickstream={{
          ...CLClickstream,
          contactID: contactId,
        }}
      />
    </Column>
  );
  return contactListeningMultitaskEnabled ? (
    <>
      {showModal && (
        <ContactListeningMultitaskingBox
          contactId={contactId}
          onClose={() => onClose()}
          column={contactListeningContentColumn}
          headerMsg={`${intl.formatMessage({
            id: 'cs_perfportal_contact_listening_contact',
            defaultMessage: 'Contact',
          })} - ${contactId}`}
          loadingState={loadingState}
          contactListeningData={contactListeningData}
          openContactTranscript={openContactTranscript}
          setOpenContactTranscript={setOpenContactTranscript}
        ></ContactListeningMultitaskingBox>
      )}
    </>
  ) : (
    <Modal
      title={intl.formatMessage({
        id: 'cs_perfportal_contact_listening_contact_details',
        defaultMessage: 'Contact Details',
        description: 'Contact Details',
      })}
      open={showModal}
      onClose={onClose}
      scrollContainer='viewport'
      closeLabel='Close'
      aria-describedby='modal-description'
      width={'750px'}
    >
      {contactListeningContentColumn}
      <ModalFooter>
        <Row alignmentHorizontal='end' widths='fit'>
          <Button type='secondary' size='small' onClick={onClose}>
            <FormattedMessage
              id='cs_perfportal_contact_listening_close'
              defaultMessage='Close'
            />
          </Button>
        </Row>
      </ModalFooter>
    </Modal>
  );
};
export default ContactListeningModal;
